















import { Component, Vue } from "vue-property-decorator";
import CompanyPageForm from "@/components/companies/CompanyPageForm.vue";
@Component({
  components: { CompanyPageForm }
})
export default class CreateCompanyView extends Vue {}
